module.exports = __webpack_public_path__ + "static/media/POTE_320G.15182b21.png";